import type { Permission } from '@/config/constants';

export interface User {
  _id: string;
  name: string;
  email: string;
  permission: Record<Permission, boolean>;
  isActive: boolean;
  isDefault: boolean;
}

export interface AddUserRequest {
  name: string;
  email: string;
  password: string;
  permission: Permission[];
}

export interface UpdateUserRequest {
  _id: string;
  name: string;
  email: string;
  password?: string;
  permission: Permission[];
}

export enum UserRequestType {
  ADD_USER_SUCCESS = 'ADD_USER_SUCCESS',
  UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS',
  DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS',
}

export interface UsersState {
  userList: User[];
  totalUsers: number;
  loading: boolean;
  error: string | null;
  requestType: UserRequestType | '';
  addUser: { loading: boolean; error: string | null };
  updateUser: { loading: boolean; error: string | null };
  emailExist: boolean;
}
